module.exports = __webpack_public_path__ + "img/order-cg.7dc9facc.png";